import { deepDefaults } from '../../styles/utils';
import { theme, setDefault } from '../../styles/theme';
import { css } from '@emotion/css';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  get transition() {
    return theme.transition.large;
  },
  fontSize: '12px',
  borderPadding: '0 24px',
  collBorder: '1px solid #eee',
  get borderRadius() {
    return theme.largeBorderRadius;
  },
  item: {
    borderBottom: '1px solid #e5e5e5',
    titleHeight: '40px',
    titleGap: '8px'
  }
};
var collapse;
setDefault(function () {
  collapse = deepDefaults(theme, {
    collapse: defaults
  }).collapse;
  makeStyles == null || makeStyles.clearCache();
  makeItemStyles == null || makeItemStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("font-size:", collapse.fontSize, ";&.", k, "-left{>.", k, "-collapse-item>.", k, "-collapse-title{flex-direction:row-reverse;}}&.", k, "-border{border-radius:", collapse.borderRadius, ";padding:", collapse.borderPadding, ";border:", collapse.collBorder, ";}");
});
export var makeItemStyles = cache(function makeItemStyles(k) {
  var collapseItem = collapse.item;
  return /*#__PURE__*/css("border-bottom:", collapseItem.borderBottom, ";&:last-of-type{border-bottom-color:transparent;}>.", k, "-collapse-title{cursor:pointer;font-weight:bold;height:", collapseItem.titleHeight, ";transition:color ", collapse.transition, ";display:flex;align-items:center;gap:", collapseItem.titleGap, ";.", k, "-collapse-title-wrapper{flex:1;}.", k, "-collapse-arrow{transition:transform ", collapse.transition, ";}}&:not(.", k, "-disabled){>.", k, "-collapse-title{&:hover{color:", theme.color.primary, ";}}}&.", k, "-active{>.", k, "-collapse-title .", k, "-collapse-arrow{transform:rotate(90deg);}}&.", k, "-disabled{color:", theme.color.disabledBorder, ";>.", k, "-collapse-title{cursor:not-allowed;}}");
});